// extracted by mini-css-extract-plugin
module.exports = {"content":"app_content__ckDFI","footer":"app_footer__3qb7a"};